import { useLayoutEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import { setIsMobile } from '../redux/storeSlice';

const MOBILE_WIDTH = 576;
let isMountedOnce = false;

export default function useIsMobileUpdater(onWindowResize?: (isMobile: boolean) => void) {
    const dispatch = useDispatch();
    const memory = useRef<boolean | null>(null);

    useLayoutEffect(() => {
        if (isMountedOnce) {
            return undefined;
        }

        isMountedOnce = true;
        window.addEventListener('resize', handleResize);
        handleResize();

        function handleResize() {
            const isMobile = window.innerWidth < MOBILE_WIDTH;
            onWindowResize?.(isMobile);

            if (isMobile !== memory.current) {
                memory.current = isMobile;
                dispatch(setIsMobile(isMobile));
            }
        }

        return () => {
            window.removeEventListener('resize', handleResize);
            isMountedOnce = false;
        };
    }, []);
}
